import { api } from '#/shared/api'

interface SendReport {
  errorMessage: string
  email: string
  file?: File
}

export async function sendReport({errorMessage, email, file}: SendReport) {
	let formData = new FormData()

	formData.append('report_text', `${email}: ${errorMessage}`)
	if (file) {
		formData.append('images', file)
	}
	return await api.post('/reports/', formData)
}
